import type { DaeMahngJiPattern } from "../../components/types";

export const dmjDemoAliasesByPattern: Record<number, string[]> = {
  1: ["daemahng_ji_1-2_combo"],
  2: ["daemahng_ji_1-2_combo"],
  3: ["daemahng_ji_3-4_combo"],
  4: ["daemahng_ji_3-4_combo"],
  5: ["daemahng_ji_5"],
  6: ["daemahng_ji_1-6_combo"],
  7: ["daemahng_ji_7"],
};

interface DmjPatternBodyProps {
  pattern: DaeMahngJiPattern;
  hasDemo?: (aliases: string[]) => boolean;
  onWatchDemo?: (aliases: string[]) => void;
}

export function DmjPatternBody({ pattern, hasDemo, onWatchDemo }: DmjPatternBodyProps) {
  if (![1, 2, 3, 4, 5, 6, 7].includes(pattern.number)) {
    return (
      <p className="text-gray-700">
        Detailed instructions for {pattern.name} will be available soon.
      </p>
    );
  }

  return (
<div className="space-y-4 pt-3">
  {/* Optional demo video link */}
  {dmjDemoAliasesByPattern[pattern.number] &&
    hasDemo?.(dmjDemoAliasesByPattern[pattern.number]) && (
      <div>
        <button
          type="button"
          className="inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
          onClick={() =>
            onWatchDemo?.(dmjDemoAliasesByPattern[pattern.number])
          }
        >
          Watch Demonstration Video
        </button>
      </div>
    )}

  <div>
    <h4 className="font-medium text-base mb-2 text-taekwondo-red">KEY</h4>
    <div className="flex flex-row items-start justify-between gap-4">
      <ul className="text-gray-700 space-y-1">
        <li>CS - Cat stance</li>
        <li>BS - Back stance</li>
        <li>FS - Front stance</li>
        <li>TS - Tiger stance</li>
        <li>KH - Knife Hand</li>
      </ul>
      <img 
        src="/images/instructions/dmc_floor_plan.png" 
        alt="DMC Floor Plan" 
        className="h-[100px] w-auto object-contain flex-shrink-0"
        loading="lazy"
      />
    </div>
  </div>
  {/* Joonbi Section */}
  <div>
    <h4 className="font-medium text-base mb-2 text-taekwondo-red">JOONBI</h4>
    <div className="text-gray-700">
      <p className="font-medium mb-2">Starting Position:</p>
      <ul className="list-disc pl-5 space-y-1">
        <li>Stand at attention stance (feet together, hands at sides). At A.</li>
        <li>Bow.</li>
        <li>Move to ready stance ("joon-bi") — step right leg out into horse stance, arms go up & round to outside ending in {pattern.number === 4 || pattern.number === 5 || pattern.number === 7 ? 'open hands' : 'closed fists'} (left over right) in front of chest{pattern.number === 3 ? ', then turn fists outwards.' : '.'}</li>
      </ul>
    </div>
  </div>

  {/* Moves Section */}
  <div>
    <h4 className="font-medium text-base mb-2 text-taekwondo-red">MOVES</h4>
    <ol className="list-none pl-1 space-y-2">
      {(pattern.number === 1 ? [
    'Turn Left (90°) into a left front stance (left leg forward). Facing B.',
    'Low block with your left arm (left downward block).',
    'Double mid punch (R/L).',
    'Turn 180° to your right (now facing opposite direction) into a right front stance. Facing C.',
    'Low block with your right arm.',
    'Double mid punch (L/R)',
    'Turn Left (90°) into a left front stance. Facing D.',
    'Low block with your left arm (left downward block).',
    'Double mid punch (R/L)',
    'Tension palm heel strike with rear arm (R)',
    'Right leg Front kick, landing in FS',
    'Double mid punch (L/R)',
    'Tension palm heel strike with rear arm (L)',
    'Left Front kick landing in FS',
    'Double mid punch (R/L)',
    'Fast palm heel strike with kihap',
    'Turn moving R leg backwards 90* into FS facing F',
    'Low block with your R arm (Right downward block).',
    'Double mid punch (L/R).',
    'Turn 180° to your left (now facing opposite direction) into a left front stance. Facing E.',
    'Low block with your left arm.',
    'Double mid punch (R/L)',
    'Turn Right (90°) into a right front stance. Facing A.',
    'Low block with your Right arm (right downward block).',
    'Double mid punch (L/R)',
    'Tension palm heel strike with rear arm (L)',
    'Left leg Front kick, landing in FS',
    'Double mid punch (R/L)',
    'Tension palm heel strike with rear arm (R)',
    'Right Front kick landing in FS',
    'Double mid punch (L/R)',
    'Fast palm heel strike (L) with kihap',
    'Turn moving L leg backwards 90* into FS facing B',
    'Low block with your left arm (left downward block).',
    'Double mid punch (R/L).',
    'Turn 180° to your right (now facing opposite direction) into a right front stance. Facing C.',
    'Low block with your right arm.',
    'Double mid punch (L/R)',
    'Turn 90* to left into BS with left tension open hand down block facing D',
    'Double mid punch (R/L)',
    'Adjust into FS rear arm fast palm heel strike with Kihap',
        'Step back to Joonbi'
      ] : pattern.number === 2 ? [
       'Turn Left (90°) into a left front stance (left leg forward). Facing B.',
'Rising block with your left arm (left high block).',
'Double high punch (R/L).',
'Turn 180° to your right (now facing opposite direction) into a right front stance. Facing C.',
'Rising block with your right arm.',
'Double high punch (L/R)',
'Turn Left (90°) into a left front stance. Facing D.',
'Rising block with your left arm (left high block).',
'Double high punch (R/L)',
'Ridge hand strike to the temple with rear arm (R), then drop arm in covering motion if front of chest & twist body to left',
'Right leg side kick, landing in FS',
'Double high punch (L/R)',
'Ridge hand strike to the temple with rear arm (L), then drop arm in covering motion if front of chest & twist body to right',
'Left side kick landing in FS',
'Double high punch (R/L)',
'Rear arm ridge hand (R) strike with kihap',
'Turn moving R leg backwards 90* into FS facing F',
'Rising block with your R arm (Right high block).',
'Double high punch (L/R).',
'Turn 180° to your left (now facing opposite direction) into a left front stance. Facing E.',
'Rising block with your left arm.',
'Double high punch (R/L)',
'Turn Right (90°) into a right front stance. Facing A.',
'Rising block with your Right arm (right high block).',
'Double high punch (L/R)',
'Ridge hand strike to the temple with rear arm (L), then drop arm in covering motion if front of chest & twist body to right',
'Left leg side kick, landing in FS',
'Double high punch (R/L)',
'Ridge hand strike to the temple with rear arm (R), then drop arm in covering motion if front of chest & twist body to left',
'Right side kick landing in FS',
'Double high punch (L/R)',
'Rear arm ridge hand (L) strike with kihap',
'Turn moving L leg backwards 90* into FS facing B',
'Rising block with your left arm (left high block).',
'Double high punch (R/L).',
'Turn 180° to your right (now facing opposite direction) into a right front stance. Facing C.',
'Rising block with your right arm.',
'Double high punch (L/R)',
'Turn 90* to left into BS with left tension open hand rising block facing D',
'Double high punch (R/L)',
'Adjust into FS rear arm ridge hand strike with Kihap',
        'Step back to Joonbi'
      ] : pattern.number === 3 ? [
    'Turn Left (90°) into a left cat stance (left leg forward). Facing B.',
'Inner Forearm outer block with your left arm (left high block).',
'Double mid punch (R/L).',
'Turn 180° to your right (now facing opposite direction) into a right CS. Facing C.',
'Inner Forearm outer block with your right arm.',
'Double mid punch (L/R)',
'Turn Left (90°) into a left back stance. Facing D.',
'Inner Forearm outer block with your left arm.',
'Double mid punch (R/L)',
'Adjust into Front Stance with a high reverse punch R.',
'Pull back into CS with cat hands',
'Right leg round kick, landing in BS',
'Double mid punch (L/R)',
'Adjust into Front Stance with a high reverse punch L.',
'Pull back into CS with cat hands',
'Left round kick landing in BS',
'Double mid punch (R/L)',
'Adjust into FS rear arm high punch (R) with kihap',
'Turn moving R leg backwards 90* into CS facing F',
'Inner Forearm outer block with your R arm.',
'Double mid punch (L/R).',
'Turn 180° to your left (now facing opposite direction) into a left cat stance. Facing E.',
'Inner Forearm outer block with your left arm.',
'Double mid punch (R/L)',
'Turn Right (90°) into a right back stance. Facing A.',
'Inner Forearm outer block with your Right arm.',
'Double mid punch (L/R)',
'Adjust into Front Stance with a high reverse punch L.',
'Pull back into CS with cat hands',
'Left round kick landing in BS',
'Double mid punch (R/L)',
'Adjust into Front Stance with a high reverse punch R.',
'Pull back into CS with cat hands',
'Right leg round kick, landing in BS',
'Double mid punch (L/R)',
'Adjust into Front Stance with a high reverse punch L Kihap',
'Turn moving L leg backwards 90* into CS facing B',
'Inner Forearm outer block with your left arm (left high block).',
'Double mid punch (R/L).',
'Turn 180° to your right (now facing opposite direction) into a right cat stance. Facing C.',
'Inner Forearm outer block with your right arm.',
'Double mid punch (L/R)',
'Turn 90* to left into BS with left tension open hand Inner Forearm outer block facing D',
'Double mid punch (R/L)',
'Adjust into FS rear arm punch R with Kihap',

        'Step back to Joonbi'
      ] : pattern.number === 4 ? [
       'Turn Left (90°) into a left BS (left leg forward). Facing B.',
'KH block with your left arm.',
'Adjust into FS reverse KH strike (R).',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch R',
'Turn 180° to your right (now facing opposite direction) into a right BS. Facing C.',
'KH block with your R arm.',
'Adjust into FS reverse KH strike (L).',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch L',
'Turn Left (90°) into a left back stance. Facing D.',
'KH block with your left arm.',
'Adjust into FS reverse KH strike (R).',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch R',
'Turn to open side (R) covering body - front arm low, rear arm high',
'R leg back kick',
'Land in FS reverse L KH strike',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch L',
'Turn to open side (L) covering body - front arm low, rear arm high',
'L leg back kick',
'Land in FS reverse R KH strike',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch R kihap',
'Turn moving R leg backwards 90* into BS facing F',
'KH block with your R arm',
'Adjust into FS reverse L KH strike',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch L',
'Turn 180° to your left (now facing opposite direction) into a left back stance. Facing E',
'KH block with your left arm.',
'Adjust into FS reverse KH strike (R).',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch R',
'Turn Right (90°) into a right back stance. Facing A.',
'KH block with your R arm.',
'Adjust into FS reverse KH strike (L).',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch L',
'Turn to open side (L) covering body - front arm low, rear arm high',
'L leg back kick',
'Land in FS reverse R KH strike',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch R kihap',
'Turn to open side (R) covering body - front arm low, rear arm high',
'R leg back kick',
'Land in FS reverse L KH strike',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch L Kihap',
'Turn moving L leg backwards 90* into BS facing B',
'KH block with your left arm',
'Adjust into FS reverse KH strike (R).',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch R',
'Turn 180° to your right (now facing opposite direction) into a right BS. Facing C.',
'KH block with your R arm.',
'Adjust into FS reverse KH strike (L).',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch L',
'Turn 90* to left into BS with left tension open hand KH block facing D',
'Adjust into FS reverse KH strike (R).',
'Pull back in to a CS with front hand motioning across body in reverse KH block',
'Adjust into FS with a high reverse punch R Kihap',
        'Step back to Joonbi'
      ] : pattern.number === 5 ? [
     'Turn Left (90°) into a left BS (left leg forward). Facing B.',
'KH guarding block.',
'Adjust into TS palm heel strike (R).',
'Pull back & lead leg up S with tiger hands',
'Adjust into FS with a high reverse palm heel strike R',
'Turn 180° to your right (now facing opposite direction) into a right BS. Facing C.',
'Repeat other side',
'Turn Left (90°) into a left back stance. Facing D.',
'KH guarding block.',
'Adjust into TS palm heel strike (R).',
'Pull back & lead leg up with tiger hands',
'Adjust into FS with a high reverse palm heel strike R',
'Drop arm & execute rear leg axe kick R',
'Land in TS rear arm L palm heel strike',
'Pull back & lead leg up with tiger hands',
'Adjust into FS with a high reverse palm heel strike L',
'Drop arm & execute rear leg axe kick L',
'Land in TS rear arm R palm heel strike Kihap',
'Turn moving R leg backwards 90* into BS facing F',
'KH guarding block',
'Adjust into TS palm heel strike (L).',
'Pull back & lead leg up with tiger hands',
'Adjust into FS with a high reverse palm heel strike L',
'Turn 180° to your left (now facing opposite direction) into a BS Facing E',
'Repeat other side',
'Turn Right (90°) into a right back stance. Facing A.',
'KH guarding block.',
'Adjust into TS palm heel strike (L).',
'Pull back & lead leg up with tiger hands',
'Adjust into FS with a high reverse palm heel strike L',
'Drop arm & execute rear leg axe kick L',
'Land in TS rear arm R palm heel strike',
'Pull back & lead leg up with tiger hands',
'Adjust into TS with a high reverse palm heel strike R',
'Drop arm & execute rear leg axe kick R',
'Land in TS rear arm L palm heel strike',
'Pull back & lead leg up with tiger hands',
'Adjust into TS with a high reverse palm heel strike L Kihap',
'Turn moving L leg backwards 90* into BS facing B',
'KH guarding block.',
'Adjust into TS palm heel strike (R).',
'Pull back & lead leg up with tiger hands',
'Adjust into TS with a high rear palm heel strike R',
'Turn 180° to your right (now facing opposite direction) into a right BS. Facing C.',
'Repeat other side',
'Turn 90* to left into BS with left tension open hand KH guarding block facing D',
'Adjust into TS rear arm palm heel strike (R).',
'Pull back & lead leg up with tiger hands',
'Adjust into TS with a high reverse palm heel strike R Kihap',

        'Step back to Joonbi'
      ] : pattern.number === 6 ? [
    'Turn Left (90°) into a left BS (left leg forward). Facing B.',
'Inner hammer block L/double mid punch R/L / L hand motion at face height in circular motion / adjust to front stance high punch R',
'Turn 180° to your right (now facing opposite direction) stepping together then out into a right BS. Facing C.',
'Repeat other side',
'Turn Left (90°) into a left back stance. Facing D.',
'Inner hammer block L /double mid punch R/L / L hand motion at face height in circular grabbing motion / adjust to front stance high punch R',
'Step rear foot up with open front hand motioning across body blocking palm up, then step front leg forward into FS with lead spear hand thrust, high rear punch, step front leg back to other foot then back foot back into BS with rear KH rising block and front arm KH down block',
'Rear leg inner crescent kick, step forward & execute a 2nd with same leg',
'Land in BS repeat other side',
'Land in BS',
'Inner hammer block L/double mid punch R/L / L hand motion at face height in circular motion / adjust to front stance high punch R - Kihap',
'Turn moving R leg backwards 90* into BS facing F',
'Inner hammer block R/double mid punch L/R / R hand motion at face height in circular motion / adjust to front stance high punch L',
'Step back together then out as you turn 180° to your left (now facing opposite direction) into a BS Facing E',
'Repeat other side',
'Step back together then out as you turn Right (90°) into a right back stance. Facing A.',
'Repeat whole middle section',
'Turn moving L leg backwards 90* into BS facing B',
'Repeat first section',
'Step back together then out as you turn 180° to your right (now facing opposite direction) into a right BS. Facing C.',
'Repeat other side',
'Step back together then out as you turn 90* to left into BS with left tension open hand reverse KH block facing D',
'Double mid punch R/L / L hand motion at face height in circular motion / adjust to front stance high punch R',
'Step rear foot up with open front hand motioning across body blocking palm up, then step front leg forward into FS with lead spear hand thrust, high rear punch KIHAP',
'Wait 3 seconds then step front leg back to other foot then back foot back into deep BS with rear rising knife hand block and front arm knife hand down block',
 'Step back to Joonbi'

      ] : pattern.number === 7 ? [
     'Turn Left (90°) into a left BS (left leg forward). Facing B.',
'Circle arms (forwards up and round) into downward KH guarding block/adjust to tiger stance lead long 45* punch with rear arm knifehand cover at face level/adjust back into cat stance lead arm downward parry & rear arm reverse mid punch/open front hand motioning across body blocking palm up/adjust to FS reverse high punch',
'Step L behind R then R forward turn 180° to your right (now facing opposite direction) into a right BS. Facing C.',
'Repeat other side',
'Step R behind L then L forward turn Left (90°) into a left back stance. Facing D.',
'Circle arms (forwards up and round)into downward KH guarding block/adjust to tiger stance lead long 45* punch with rear arm knifehand cover at face level/adjust back into cat stance lead arm downward parry & rear arm reverse mid punch/open front hand motioning across body blocking palm up/adjust to FS reverse high punch',
'Step rear foot up past front (swan step) with open front hand motioning across body to waist palm down, then step front leg forward into FS with lead KH strike, high rear punch, step front leg back to other foot then back foot back & drag front foot back into short T stance (front heel slightly raised) with rear high palm heel to rear and front arm straight palm heel (both in tension)',
'Rear arm reverse ridge hand block, then rear leg twisting kick R while blocking the groin with R hand, step forward & execute a 2nd twisting kick with same leg (including groin block)',
'Land R leg forward into BS repeat other side',
'Land in BS',
'Circle arms (forwards up and round) into downward KH guarding block/adjust to tiger stance lead long 45* punch with rear arm knifehand cover at face level/adjust back into cat stance lead arm downward parry & rear arm reverse mid punch/open front hand motioning across body blocking palm up/adjust to FS reverse high punch  - Kihap',
'Turn moving R leg backwards 90* into BS facing F.',
'Circle arms (forwards up and round) into downward KH guarding block/adjust to tiger stance lead long 45* punch with rear arm knifehand cover at face level/adjust back into cat stance lead arm downward parry & rear arm reverse mid punch/open front hand motioning across body blocking palm up/adjust to FS reverse high punch',
'Step R leg behind L, then left into BS as you turn 180° to your left (now facing opposite direction) Facing E.',
'Repeat other side',
'Step L behind R then R forward turn Right (90°) into a right back stance. Facing A.',
'Repeat whole middle section',
'Turn moving L leg backwards 90* into BS facing B.',
'Repeat first section',
'Step L behind R then R forward turn 180° to your right (now facing opposite direction) into a right BS. Facing C.',
'Repeat other side',
'Step R behind L then L forward as you turn 90* to left into BS circling arms (forwards up and round) left tension open hand Downward KH guarding block facing D.',
'Adjust to tiger stance lead long 45* punch with rear arm KH cover at face level/adjust back into cat stance lead arm downward parry & rear arm reverse mid punch/open front hand motioning across body blocking palm up/adjust to FS reverse high punch',
'Step rear foot up past front (swan step) with open front hand motioning across body to waist palm down, then step front leg forward into FS with lead KH strike, high rear punch KIHAP',
'Wait 3 seconds then step front leg back to other foot then back foot back & drag front foot back into short T stance (front heel slightly raised) with rear high palm heel to rear and front arm straight palm heel (both in tension)',
        'Step back to Joonbi'
      ] : []).map((step, index) => (
        <li key={index} className="flex">
          <span className="text-taekwondo-red mr-2">{index + 1}.</span>
          <span className="text-gray-700">{step.includes('KIHAP') ? (
            <>
              {step.replace(' KIHAP', '')} <span className="font-semibold">KIHAP</span>
            </>
          ) : step}</span>
        </li>
      ))}
    </ol>
  </div>
</div>
  );
}
